import { useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'settings',
  })

  return function onClick() {
    submit({ type: 'reset' })
  }
}
